import { SalesActionsType } from 'api-hooks/general/model';
import { SaleModel } from 'api-hooks/sale/common';
import { NavigationRoutes } from 'common/constants';
import { SaleStatusEnum } from 'common/constants/enum';
import { FormAutoSaver } from 'common/helpers/form-auto-saver';
import { PopoverMenuType } from 'components/popover';
import useNavigation from 'hooks/use-navigation';
import { SaleInvoiceRefundType } from 'legacy-modules/refund/refund/components/form';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

export default function useSalesRefund(
  type: SalesActionsType,
  data: SaleModel,
) {
  const { t } = useTranslation();
  const { navigate } = useNavigation();

  const status = data.status;

  const isAllowed = React.useMemo(() => {
    switch (status) {
      case SaleStatusEnum.Completed:
      case SaleStatusEnum.Refund:
        return true;
      default:
        return false;
    }
  }, [status]);

  const refundPermission = isAllowed;

  const transactionSaleType = React.useMemo(() => {
    switch (type) {
      case 'flight-sales':
        return 'flight';
      case 'hotel-sales':
        return 'hotel';
      case 'cruise-sales':
        return 'cruise';
      case 'document-sales':
        return 'document';
      case 'activity-sales':
        return 'activity';
      case 'product-sales':
        return 'product';
      case 'tour-sales':
        return 'tour';
    }
  }, [type]);

  const onRefund = React.useCallback(() => {
    const invoice: SaleInvoiceRefundType = {
      id: data.id,
      invoiceNumber: data.invoiceNumber,
      customerId: data.customer.id,
      customerBillingId: data.customerBillingAddress?.id ?? null,
      code: data.code,
      description: data.description,
      transactionAt: data.transactionAt,
      total: data.total,
      refId: data.refId,
      adminId: data.admin.id,
      operatorId: data.operator?.id,
      salesmanId: data.salesman?.id,
      label: `${data.invoiceNumber} - ${data.code} - ${data.customer.name}`,
      transactionSaleType,
    };
    FormAutoSaver.remove(NavigationRoutes.RefundCreate);
    navigate(NavigationRoutes.RefundCreate, {
      invoice,
    });
  }, [data, navigate, transactionSaleType]);

  const refundAction: PopoverMenuType = {
    label: t('common:create_extra', { extra: t('common:order') }),
    onClick: onRefund,
    isAllowed: refundPermission,
    isError: false,
    key: `refund-${data.id}`,
  };

  return {
    refundPermission,
    transactionSaleType,
    onRefund,
    refundAction,
  };
}
